import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { Layout } from 'components/Layout'
import { PointCardOfferTemplate } from 'components/Templates'

const PointCardOfferEdit: FC = () => {
  const pathname = useSelector((state: State) => state.router.location.pathname)
  const isEdit = /^\/point_card\/offer\/(?!create$)[^/]+$/.test(pathname)
  const pointCardOfferId = isEdit ? pathname.split('/point_card/offer/')[1] : undefined

  return (
    <Layout iconPath={'/icon/white/point_card.svg'} headline={'特典'} title={'特典'}>
      <PointCardOfferTemplate isEdit={isEdit} pointCardOfferId={pointCardOfferId} />
    </Layout>
  )
}

export default PointCardOfferEdit
